"use client"
import { ComponentConfig } from "@measured/puck"
import { RenderConfig, SectionFilterProps } from "./RenderConfig"

export const SectionFilter: ComponentConfig<SectionFilterProps> = {
  label: "Section Filter",
  fields: {
    heading1: {
      label: "Heading 1",
      type: "text",
    },
    text1: {
      label: "Text 1",
      type: "text",
    },
    text2: {
      label: "Text 2",
      type: "text",
    },
    heading2: {
      label: "Heading 2",
      type: "text",
    },
    text3: {
      label: "Text 3",
      type: "text",
    },
    text4: {
      label: "Text 4",
      type: "text",
    },
    heading3: {
      label: "Heading 3",
      type: "text",
    },
    text5: {
      label: "Text 5",
      type: "text",
    },
    text6: {
      label: "Text 6",
      type: "text",
    },
  },
  defaultProps: {
    heading1: "Heading 1",
    text1: "Text 1",
    text2: "Text 2",
    heading2: "Heading 2",
    text3: "Text 3",
    text4: "Text 4",
    heading3: "Heading 3",
    text5: "Text 5",
    text6: "Text 6",
  },
  render: RenderConfig.render,
}
